import {createSlice} from "@reduxjs/toolkit";

const ScheduleDayExtendedSlice = createSlice({
    name: "scheduleDayExtended",
    initialState: {
        date: null,
        lessons: [
        
    ]
    },
    reducers: {
        update: (state, action) => {
            return {...action.payload}
        }
    }
})

export default ScheduleDayExtendedSlice.reducer;
export const {update: updateDayLessonData} = ScheduleDayExtendedSlice.actions;